import { REQUEST_STATUS_STATE, useGetRequestState } from '@ab-core-functions/reward-shop';
import { userHasPermissions } from '@ab-core-functions/user-permission';
import { BREAKPOINT } from '@ab-core/breakpoints';
import { isShopApp, useIsFeatureVisible } from '@ab-core/functions';
import { useIsMobile } from '@ab-core/functions/useIsMobile';
import type { FC } from 'react';
import React from 'react';
import { NavigationElement } from './navigation';
import { TitleElement } from './title';
import type { ContentItem } from './types';
import { navigation } from './utils/elementsObjects';

type ShopElementsProps = {
    pathName: string;
    onClose?: () => void;
};

export const ShopElements: FC<ShopElementsProps> = (props) => {
    const { pathName, onClose } = props;
    const isMobile = useIsMobile(BREAKPOINT.LG);
    const isApp = isShopApp();
    const userRequestState = useGetRequestState();
    const { isFeatureVisible } = useIsFeatureVisible();

    const navigationWithoutPremium = navigation.map((item) => {
        return {
            ...item,
            content:
                userRequestState === REQUEST_STATUS_STATE.REJECTED
                    ? item.content.filter((c: ContentItem) => c.featureName !== 'praemienShop')
                    : item.content
        };
    });

    const filterNavigation = navigationWithoutPremium.map((item) => ({
        ...item,
        content: item.content.filter((content: ContentItem) => {
            const hasPermission = !content.permissionName || userHasPermissions(content.permissionName);
            const isExcluded = content.excludePermissionName && userHasPermissions(content.excludePermissionName);
            const isContentVisible = isFeatureVisible(content.featureName || '');
            const visibleOnViewport = content.onlyMobile ? isMobile || isApp : true;

            return hasPermission && isContentVisible && visibleOnViewport && !isExcluded;
        })
    }));

    return (
        <div className="my-medium">
            {filterNavigation?.map(
                (section, index) =>
                    section.content.length > 0 && (
                        <React.Fragment key={index}>
                            <TitleElement headline={section.headline} />
                            <NavigationElement content={section.content} pathName={pathName} onClose={onClose} />
                        </React.Fragment>
                    )
            )}
        </div>
    );
};
